import { render, staticRenderFns } from "./EmailUpdateConfirm.vue?vue&type=template&id=2f0de0ee&"
import script from "./EmailUpdateConfirm.vue?vue&type=script&lang=js&"
export * from "./EmailUpdateConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports